var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { memoize } from '../../utils/mobx/decorators/memoize';
import { GlobalTextSizer } from './textsizer/GlobalTextSizer';
import { Consistencer } from './consistencer/Consistencer';
import { Hooker } from './hooker/Hooker';
import { Eventor } from './eventor/Eventor';
import { Mutator } from './mutator/Mutator';
import { DirectorQuestion } from './question/DirectorQuestion';
export class Director {
    parent;
    constructor(parent) {
        this.parent = parent;
        this.mutator = new Mutator(this);
    }
    get app() {
        return this.parent;
    }
    get textSizer() {
        return new GlobalTextSizer(this);
    }
    get hooker() {
        return new Hooker(this);
    }
    get eventor() {
        return new Eventor(this);
    }
    consistencer = new Consistencer(this);
    mutator;
    directorQuestion = new DirectorQuestion(this);
}
__decorate([
    memoize
], Director.prototype, "textSizer", null);
__decorate([
    memoize
], Director.prototype, "hooker", null);
__decorate([
    memoize
], Director.prototype, "eventor", null);
